import { DateHelper } from "../../../../Common/DateHelper";
import { ODataSelect } from "../../../../Providers.Api/ODataQuery";

export class TicketedEvent extends ODataSelect
{
    public Node_Id = 0;
    public Ticketed_Event_Id = "";
    public Booking_Id = "";
    public Event_Title = "";
    public Event_Date = DateHelper.null();
    public Event_Start_DateTime = DateHelper.null();
    public Event_End_DateTime = DateHelper.null();

    public init(response: any, nodeId: number): TicketedEvent
    {
        super.init(response, nodeId);
        this.Event_Date = DateHelper.fromIsoByNode(response.Event_Date, nodeId);
        this.Event_Start_DateTime = DateHelper.fromIsoByNode(response.Event_Start_DateTime, nodeId);
        this.Event_End_DateTime = DateHelper.fromIsoByNode(response.Event_End_DateTime, nodeId);
        return this;
    }
}

export class BookingDetails extends ODataSelect
{
    public Booking_Id = "";
    public Space_Name = "";
    public Space_Id = "";
}

